import { render, staticRenderFns } from "./PlaylistMain.html?vue&type=template&id=3bf01216&scoped=true&"
import script from "./PlaylistMain.vue?vue&type=script&lang=js&"
export * from "./PlaylistMain.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistMain.css?vue&type=style&index=0&id=3bf01216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf01216",
  null
  
)

export default component.exports